import { render, staticRenderFns } from "./CampaignTabWrapper.vue?vue&type=template&id=7667d395&"
import script from "./CampaignTabWrapper.vue?vue&type=script&lang=js&"
export * from "./CampaignTabWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CampaignTabWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports